import React from "react";
import { Link } from "react-router-dom";
import { Button, Container, Typography, Box, Paper, Avatar } from "@mui/material";
import { useStore } from "../../app/stores/store";
import LoginForm from "../users/LoginForm";
import { UserRole } from "../../app/common/enums/userRole";
import { useTranslation } from "react-i18next";

export default function WelcomePage() {
  const userStore = useStore((s) => s.userStore);
  const modalStore = useStore((s) => s.modalStore);
  const { t } = useTranslation();

  return (
    <Paper
      sx={{
        position: "fixed",
        inset: 0,
        width: "100%",
        minHeight: "100dvh",
        m: 0,
        p: 0,
        borderRadius: 0,
        overflow: "hidden",
        background:
          "linear-gradient(135deg, #388e3c 0%, #a5d6a7 90%, #e6c200 98%, #fffde7 100%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        textAlign: "center",
        boxSizing: "border-box",
      }}
      elevation={0}
      square
    >
      <Container maxWidth="sm" disableGutters>
        <Box sx={{ mb: 3, px: 2 }}>
          <Avatar
            src="/assets/logo.png"
            alt="logo"
            sx={{ width: 120, height: 120, mx: "auto", mb: 2 }}
          />
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              textShadow: "0 2px 8px rgba(0,0,0,0.25)",
            }}
          >
          </Typography>
        </Box>
        {userStore.isLoggedIn ? (
          <>
            <Typography variant="h5" sx={{ mb: 3, px: 2 }}>
              {t("welcomePage.welcomeBack")} {userStore.loggedUser?.username}
            </Typography>
            <Box sx={{ px: 2 }}>
              <Button
                variant="contained"
                color="success"
                size="large"
                component={Link}
                to={
                  userStore.userRole === UserRole.SUPER_ADMIN
                    ? "/users-create"
                    : "/home"
                }
                sx={{ fontSize: 18, px: 4, py: 1.5 }}
              >
                {t("welcomePage.enterApp")}
              </Button>
            </Box>
          </>
        ) : (
          <Box sx={{ px: 2 }}>
            <Button
              variant="contained"
              color="success"
              size="large"
              onClick={() => modalStore.openModal(<LoginForm />)}
              sx={{ fontSize: 18, px: 4, py: 1.5 }}
            >
              {t("welcomePage.login")}
            </Button>
          </Box>
        )}
      </Container>
    </Paper>
  );
}
